var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVaporizer = function SvgVaporizer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#061E21",
    clipPath: "url(#vaporizer_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.76 14.43c-1.63 1.63-.36 3.01 1.27 4.64s3.06 2.86 4.69 1.22l2.27-2.27-5.91-5.91-2.31 2.31zM18.86 0 15.4.62c-.53 0-1.04.21-1.41.59l-9.5 9.5 5.91 5.91 9.5-9.5c.38-.38.59-.88.59-1.41l.51-3.7C21 1.46 19.42 0 18.86 0m-5.5 9.37c-.92 0-1.66-.74-1.66-1.66s.74-1.66 1.66-1.66 1.66.74 1.66 1.66-.74 1.66-1.66 1.66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "vaporizer_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v21.07H0z"
  })))));
};
export default SvgVaporizer;